import { Size } from '../../../../../Enums/Size.enum';
import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import useWorkplaceManager from '../../../Hooks/useWorkplaceManager';
import ManagerWorkplaceForm from '../ManagerWorkplaceForm/ManagerWorkplaceForm';
import {
	useDeleteWorkplaceMutation,
	useUpdateWorkplaceMutation,
} from '../../../../../graphql/graphql';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import styles from './ManagerWorkplaceEdit.module.scss';
import { WorkplacesTreeItem } from '../ManagerWorkplaceWrapper/ManagerWorkplaceWrapper';
import findChildrenFoldersIds from '../../../../Workplace/Helpers/Workplace/findChildrenFoldersIds.helper';

interface Props extends BaseModalProps {
	item: WorkplacesTreeItem;
	onChange: () => void;
}

const ManagerWorkplaceEdit = ({ item, onChange, ...otherProps }: Props) => {
	const { workplaceFolderFormScheme } = useWorkplaceManager([
		item.id,
		...findChildrenFoldersIds(item.children),
	]);
	const [updateWorkplaceMutation] = useUpdateWorkplaceMutation();
	const [deleteWorkplaceMutation] = useDeleteWorkplaceMutation();
	const { displayGQLError, displaySuccess } = useApiClient();

	const handleEdit = async ({ name, parentId }: any) => {
		const result = await updateWorkplaceMutation({
			where: { id: item.id },
			data: {
				name,
				parentWorkplaceId: parentId.value,
			},
		});

		if ('error' in result) {
			displayGQLError(result);
		} else {
			onChange();
		}
	};

	const handleDelete = async () => {
		const result = await deleteWorkplaceMutation({ id: item.id });

		if ('error' in result) {
			displayGQLError(result);
		} else {
			displaySuccess('component.caseType.managementUnitWasDeleted');
			onChange();
		}
	};

	const defaultValues = {
		name: item?.name || '',
		parentId: item?.parentWorkplace?.id
			? {
					value: item.parentWorkplace.id,
					label:
						item.parentWorkplace.doctorDisplayName || item.parentWorkplace.name,
			  }
			: undefined,
	};

	return (
		<BaseModal
			{...otherProps}
			size={Size.MD}
			title={'component.caseType.editManagementUnit'}>
			<div>
				<ManagerWorkplaceForm
					formScheme={workplaceFolderFormScheme}
					onSubmit={handleEdit}
					submitButtonText={'base.shared.save'}
					defaultValues={defaultValues}
				/>
				<div className={styles.buttonContainer}>
					<LinkButton
						title={'component.caseType.deleteManagementUnit'}
						theme={Theme.BLUE}
						onClick={handleDelete}
					/>
				</div>
			</div>
		</BaseModal>
	);
};

export default ManagerWorkplaceEdit;
